export const couponOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuWidth:380,
  // labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "优惠券名称",
      prop: "name",
      search: true,
    },
    {
      label: "优惠码",
      prop: "code",
    },
    {
      label: "类型",
      prop: "type",
      search: true,
      dicData: [
        {
          label: "优惠券",
          value: 0,
        },
        {
          label: " 抵扣券",
          value: 1,
        },
      ],
    },
   
    {
      label: "开始时间",
      prop: "startDate",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "结束时间",
      prop: "endDate",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "抵扣价格",
      prop: "price",
    },
    {
      label: "使用范围",
      prop: "useType",
      solt: true,
      /* dicData: [
        {
          label: "通用",
          value: 0,
        },
        {
          label: "商品",
          value: 1,
        },
      ], */
    },
    {
      label: "组合套餐",
      prop: "combination",
      dicData: [
        {
          label: "是",
          value: 0,
        },
        {
          label: "否",
          value: 1,
        },
      ],
    },
    {
      label: "提示语",
      prop: "prompt",
    },
    {
      label: "说明",
      prop: "remarks",
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
